<template>
  <j-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '800px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('计划类型')" prop="planType">
                <j-dict-select-tag v-model="model.planType" :placeholder="$t('请选择计划类型')" dictCode="plan_type" style="width:100%" :disabled="model.id"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('计划名称')" prop="planName">
                <a-input v-model="model.planName" :placeholder="$t('请输入计划名称')" :disabled="model.id"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('计划类别')" prop="planCategory">
                <a-select :placeholder="$t('请选择计划类别')" v-model="model.planCategory" :disabled="model.id">
                  <a-select-option :value="0">{{ $t('重点区域') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('查漏专项') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('计划区域')" prop="planArea">
                <a-input v-model="model.planArea" :placeholder="$t('请选择区域')" :readOnly="true" @click="setModalVisible()" :disabled="model.id"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('周期')" prop="customCycleValue" :rules="customCycleValueRules(model)">
                <div class="form-item-series">
                  <a-input-number v-model="model.customCycleValue" :min="0" :placeholder="$t('请输入周期值')" style="width: 100%" :disabled="model.id||model.customCycleType=='TIME_CYCLE_TYPE_ONCE'" />
                  <j-dict-select-tag v-model="model.customCycleType" :placeholder="$t('请选择周期类型')" dictCode="customCycleType" :showSearch="false" @input="cycleTypeChange" :disabled="model.id"/>
                </div>
              </a-form-model-item>
            </a-col>
            <template v-if="model.customCycleType != 'TIME_CYCLE_TYPE_ONCE'">
              <a-col :span="8">
                <a-form-model-item :label="$t('启用时间')" prop="customCycleStartTime">
                  <a-date-picker :showTime="{ format: 'HH' }" v-model="model.customCycleStartTime" :disabled-date="disabledDate" value-format="YYYY-MM-DD HH" format="YYYY-MM-DD HH" style="width: 100%" :placeholder="$t('请选择启用时间')" :disabled="model.id" />
                </a-form-model-item>
              </a-col>
            </template>
            <a-col :span="8">
              <a-form-model-item :label="$t('测点实体')" prop="planEntitiy">
                <!-- <a-select placeholder="请选择测点实体" v-model="model.planEntitiy" :disabled="model.id">
                  <a-select-option :value="0">管网</a-select-option>
                  <a-select-option :value="1">阀门</a-select-option>
                  <a-select-option :value="2">水表</a-select-option>
                  <a-select-option :value="3">水厂设备</a-select-option>
                </a-select> -->
                <j-dict-select-tag v-model="model.planEntitiy" :placeholder="$t('请选择测点实体')" dictCode="planEntitiy" :showSearch="false" :disabled="model.id"/>
              </a-form-model-item>
            </a-col>
          <!-- </a-row>
          <a-row :gutter="24"> -->
            <a-col :span="8">
              <a-form-model-item :label="$t('巡检方式')">
                <a-select :placeholder="$t('请选择巡检方式')" v-model="model.planManner" @change="planMannerChange" :disabled="model.id">
                  <a-select-option :value="0">{{ $t('步巡') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('车巡') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('其他指标')" prop="planOtherRequest">
                <a-input v-model="model.planOtherRequest" :placeholder="$t('请输入其他指标')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('巡检要求')" prop="planRequest">
                <a-input v-model="model.planRequest" :placeholder="$t('请输入巡检要求')" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('选择路线')" prop="routeIds">
                <a-select mode="multiple" show-search option-filter-prop="children" v-model="model.routeIds" :placeholder="$t('请选择路线')" @change="handleChange" :disabled="model.id">
                  <a-select-option v-for="item in routeList" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('路线详情')">
                <div style="width: 100%;height: 400px;" id="amapDiv">
                  <baidu-map 
                  v-if="visible"
                  :center="center" 
                  :zoom="zoom" 
                  :style="{height: 380+'px'}"
                  :scroll-wheel-zoom="scrollZoom" 
                  NavigationControlType="BMAP_NAVIGATION_CONTROL_LARGE" 
                  @ready="mapReady">
                    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"/>
                    <!-- 信息窗体 -->
                    <bm-info-window :position="position" :show="show" @close="infoWindowClose" @open="infoWindowOpen">
                        <div style="width:300px;display:flex;justify-content: space-between;font-weight: bold;">
                            <div>
                              <div>{{ $t('设备编号') }}：{{mapInfo.deviceNum}}</div>
                              <div>{{ $t('设备名称') }}：{{mapInfo.deviceName}}</div>
                              <div>{{ $t('设备类型') }}：{{deviceTypeList.find(d=>d.value == mapInfo.deviceType) && deviceTypeList.find(d=>d.value == mapInfo.deviceType).text}}</div>
                              <div>{{ $t('设备经度') }}：{{mapInfo.detectLongitude}}</div>
                              <div>{{ $t('设备纬度') }}：{{mapInfo.detectLatitude}}</div>
                            </div>
                        </div>
                    </bm-info-window>
                  </baidu-map>
                </div>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" :disabled="model.id" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <a-modal v-model="modal2Visible" :title="title2" centered :width="800" :body-style="{ height: '500px', overflow: 'hidden', overflowY: 'scroll' }" :maskClosable="false">
        <template slot="footer">
            <a-button key="close" @click="handleCancel1">
            {{ $t('关闭') }}
            </a-button>
        </template>
        <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" allowClear :placeholder="$t('请输入区域名称')"/>
        <a-spin tip="Loading..." :spinning="areaLoading">
            <el-tree
                class="filter-tree"
                :data="areaTree"
                :props="defaultProps"
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                :check-on-click-node="true"
                :check-strictly="checkStrictly"
                :highlight-current="true"
                node-key="id"
                :current-node-key="currentNodeKey"
                :default-expanded-keys="iExpandedKeys"
                @node-click="nodeClick"
                ref="areaTree">
                </el-tree>
        </a-spin>
    </a-modal>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {
    getDictItemsFromCache
  } from '@/api/api.js'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
import JDictSelectTag from '../../../../components/dict/JDictSelectTag.vue'
import moment from 'moment'
  export default {
    mixins: [AreaChoosetMixin],
    name: 'inspectionPlanModal',
    components: {JDictSelectTag},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-engineering/inspection/inspectionPlan/add",
          edit: "/jeecg-engineering/inspection/inspectionPlan/edit",
          queryById: "/jeecg-engineering/inspection/inspectionPlan/queryById",
          list: "/jeecg-engineering/inspection/inspectionRoute/list",
          routeQueryById: "/jeecg-engineering/inspection/inspectionRoute/queryById",
          queryAreaTreeList: "/jeecg-engineering/inspection/inspectionArea/queryAreaTreeList",
        },
        routeList: [],
        // 定义地图数据
        BMap: "",
        map: "",
        center: { lng: 118.904, lat: 31.915 },//中心坐标
        centerPoint: { lng: 118.904, lat: 31.915 },
        zoom: 17, //初始缩放比
        scrollZoom: true,//允许鼠标滚轮缩放
        //折线颜色和标注icon
        colorAndIcon: [
          { lineColor: "#b083fb", icon: require("@/assets/sbdw.png") },
          { lineColor: "#b08xab", icon: require("@/assets/duban.png") },
        ],
        //线路坐标信息
        lineMapList: [],
        //站点坐标信息
        stationMapList: [],
        searchAddresKeywords: '',
        localList: [],
        allLine:{},
        show: false,
        position: {},
        mapInfo: {},
        lineColorList:["#b083fb","#b08",'#1890FF','#AFEEEE','#cc0000'],
        lineColorIndex: 1,
        deviceTypeList: [],
        modal2Visible: false,
        currSelected: {},
      }
    },
    created(){
      this.deviceTypeList = getDictItemsFromCache('deviceType');
    },
    computed: {
      title2() {
        return this.$t('请选择区域名称')
      },
      validatorRules() {
        return {
          planType: [{
            required: true,
            message: this.$t('请输入计划类型'),
            trigger: 'blur'
          }],
          planName: [{
            required: true,
            message: this.$t('请输入巡检方案名称'),
            trigger: 'blur'
          }],
          planCategory: [{
            required: true,
            message: this.$t('请选择计划类别'),
            trigger: 'change'
          }],
          planArea: [{
            required: true,
            message: this.$t('请输入计划区域'),
            trigger: 'blur'
          }],
          planEntitiy: [{
            required: true,
            message: this.$t('请选择测点实体'),
            trigger: 'change'
          }],
          customCycleType: [{
            required: true,
            message: this.$t('请选择周期类型'),
            trigger: 'change'
          }],
          customCycleValue: [{
            required: true,
            message: this.$t('请输入周期值'),
            trigger: 'change'
          }],
          isFeedback: [{
            required: true,
            message: this.$t('请选择是否反馈'),
            trigger: 'change'
          }],
          isRoutine: [{
            required: true,
            message: this.$t('请选择是否常规'),
            trigger: 'change'
          }],
          planManner: [{
            required: true,
            message: this.$t('请选择巡检方式'),
            trigger: 'change'
          }],
          routeIds: [{
            required: true,
            message: this.$t('请选择路线'),
            trigger: 'change'
          }]
        }
      },
    },
    methods: {
      cycleTypeChange(e){
        if(e == 'TIME_CYCLE_TYPE_ONCE'){
          this.$set(this.model, 'customCycleValue', 1);
          this.$set(this.model, 'customCycleStartTime', '');
        }
      },
      disabledDate (current) {
        return current < moment().startOf('day') 
      },
      customCycleValueRules(record) {
        return [
          {
            required: true,
            validator: (rule, value, callback) => {
              if(record.customCycleType == 'TIME_CYCLE_TYPE_ONCE'){
                callback()
              }else{
                if (value == null || value === '') {
                  callback(new Error(this.$t('请输入周期值')))
                } else {
                  callback()
                }
              }
            },
            trigger: ['change', 'blur'],
          },
        ]
      },
      setModalVisible(){
        this.loadTree()
        this.modal2Visible = true;
      },
      loadTree(){
        this.areaLoading = true
        var that = this
        that.areaTree = []
        getAction(this.url.queryAreaTreeList).then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            // this.allTreeKeys = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.areaTree.push(temp)
              that.setThisExpandedKeys(temp)
            }
            
          }
        }).finally(()=> {
          this.areaLoading = false
        })
      },
      setThisExpandedKeys(node) {
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.key)
        }
      },
      nodeClick(record,node,data) {
        // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
          this.currentNodeKey = record.id
          this.$refs.areaTree.setCheckedKeys([record.id])
          //this.$refs.areaTree.setCurrentKey(record.id)
          this.currSelected = Object.assign({}, record);
          // 有的接口是areaId有的接口是userAreaId，兼容两个都写
          //  this.form.setFieldsValue({
          // 'userAreaName' : this.currSelected.areaName,
          // });
          // this.model.planArea = this.currSelected.areaName
          this.$set(this.model,'planArea',this.currSelected.areaName);
          this.$set(this.model,'planAreaId',this.currSelected.id);
          this.$refs.form.validateField('planArea');
          this.modal2Visible = false
      },
      handleCancel1(){
        this.modal2Visible = false;
        this.currSelected = {};
        this.queryParam = {}
      },
      planMannerChange(){
        this.map.clearOverlays();
        this.drawMap();
      },
      // 关闭窗体
      infoWindowClose () {
          this.show = false
      },
      // 打开窗体
      infoWindowOpen () {
          this.show = true
      },
      drawMap(){
        let that = this;
        let BMap = this.BMap;
        let map = this.map;
        let data = []; //线路
        let data2 = []; //站点
        
        for(let key in this.allLine){
          data.push(this.allLine[key]);
        }
        data2 = data.join(',').split(',');
          
        // 这里是数据改变时，地图中心点定位到当前第一条数据的第一个坐标点或者默认的中心坐标
        let point = data.length && data[0].length ? data[0][0] : this.centerPoint;
        this.center = { lng: point.detectLongitude, lat: point.detectLatitude };
        this.zoom = 17;
        this.map.centerAndZoom(this.center, 14);
          
        // 线路坐标信息 数据类型：数组包数组
        for (let i = 0; i < data.length; i++) {
          let points = [];
          for (let j = 0; j < data[i].length; j++) {
            points.push(new BMap.Point(data[i][j].detectLongitude, data[i][j].detectLatitude));
          }
          this.addPolyline(BMap, map, data, points, i);//调用添加折线方法
        }
        // 站点坐标信息 数据类型：数组包对象
        for (let i = 0; i < data2.length; i++) {
          let points = [];
          points.push(new BMap.Point(data2[i].detectLongitude, data2[i].detectLatitude));
          this.addStation(BMap, map, data2, points, i);//调用添加站点方法
        }
        
        if(this.model.planManner == 0){//步巡
        // this.map.clearOverlays();
          // 两个设备之间的步行路线
          var walking = new BMap.WalkingRoute(map,{
            onSearchComplete: function(result){
              if(walking.getStatus() == BMAP_STATUS_SUCCESS){
                var pts = walking.getResults().getPlan(0).getRoute(0).getPath();
                that.map.addOverlay(new BMap.Polyline(pts, { strokeColor: that.lineColorList[that.lineColorIndex], strokeWeight: 3, strokeOpacity: 1 }));
              }
            }
          },{
            renderOptions: {
              map: map,
            }
          })
          if(this.model.routeIds.length == data.length){
            for(let k=0;k<data.length;k++){
              for(let h=0;h<data[k].length;h++){
                walking.search(new BMap.Point(data[k][h].detectLongitude, data[k][h].detectLatitude),new BMap.Point(data[k][h+1] && data[k][h+1].detectLongitude, data[k][h+1]&&data[k][h+1].detectLatitude));
                
              }
            }
          }
          
        }else{//车巡
          // this.map.clearOverlays();
          // 两个设备之间的驾车路线
          var longpatStr = '';
          var driving = new BMap.DrivingRoute(map,{
            onSearchComplete: function(result){
              if(driving.getStatus() == BMAP_STATUS_SUCCESS){
                var pts = driving.getResults().getPlan(0).getRoute(0).getPath();
                var paths = pts.length;
                for (var i = 0; i < paths; i++) {
                	console.log(pts[i].lng + " " + pts[i].lat); 
                	longpatStr += parseFloat(pts[i].lat) + "|" + parseFloat(pts[i].lng) + ","
                }
                that.line(longpatStr)
              }
            }
          },{
            renderOptions: {
              map: map,
              autoViewport: true
            }
          })
          if(this.model.routeIds.length == data.length){
            for(let k=0;k<data.length;k++){
              for(let h=0;h<data[k].length;h++){
                driving.search(new BMap.Point(data[k][h].detectLongitude, data[k][h].detectLatitude),new BMap.Point(data[k][h+1] && data[k][h+1].detectLongitude, data[k][h+1]&&data[k][h+1].detectLatitude));
              }
            }
            
          }
        }
        
      },
      line(lonlat) {
      	var co = lonlat.split(",");
      	var pointAttr = new Array();
      	for (var i = 0; i < co.length-1; i++) {
      		var loglats = co[i].split("|")
      		var point = new BMap.Point(loglats[1], loglats[0])
      		pointAttr.push(point);
      	}
      	var polyline = new BMap.Polyline(pointAttr, {
      		strokeColor: this.lineColorList[this.lineColorIndex],
      		strokeWeight: 3,
      		strokeOpacity: 1
      	});
        
      	this.map.addOverlay(polyline);
        
      	var loglats = co[0].split("|")
      	this.map.centerAndZoom(new BMap.Point(loglats[1], loglats[0]), 15);
      },
      handleChange(val){
        let that = this;
        that.allLine = {};
        this.map.clearOverlays()
        if(val.length>0){
          val.map(v=>{
            getAction(this.url.routeQueryById,{id:v}).then(res=>{
              if(res.success){
                this.$set(that.allLine,v,res.result.inspectionTaskRouteDeviceList);
                // 添加信息框
                this.map.addEventListener("click", (e) => {
                  this.mapInfo = Object.values(that.allLine).flat().find(al=>al.deviceId == e.cb.Bc.textContent);
                  this.position = {
                    lng: this.mapInfo.detectLongitude,
                    lat: this.mapInfo.detectLatitude,
                  };
                  this.show = true;
                });
                this.drawMap();
              }
            });
          });
        }
      },
      getrouteList() {
        this.routeList = [];
        getAction(this.url.list,{pageSize:999,order: 'desc',column: 'createTime'}).then(res => {
          if (res.success) {
            res.result.records.forEach(item => {
              this.routeList.push({
                name:item.routeName,
                id:item.id
              });
            });
          }
        });
      },
      add() {
        this.visible = true;
        this.model = {
          customCycleType: 'TIME_CYCLE_TYPE_DAY',
        };
        this.getrouteList();
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      },
      edit(record) {
        let that = this;
        this.visible = true;
        getAction(this.url.queryById,{id:record.id}).then(res=>{
          if(res.success){
            let routeIds = [];
            res.result.inspectionRouteVOList && res.result.inspectionRouteVOList.forEach(item=>{
              routeIds.push(item.id);
            });
            this.$set(this.model,'routeIds',routeIds);
            that.allLine = {};
            that.model.routeIds.map(v=>{
              getAction(this.url.routeQueryById,{id:v}).then(res=>{
                if(res.success){
                  this.$set(that.allLine,v,res.result.inspectionTaskRouteDeviceList);
                  // 添加信息框
                  this.map.addEventListener("click", (e) => {
                    this.mapInfo = Object.values(that.allLine).flat().find(al=>al.deviceId == e.cb.Bc.textContent);
                    this.position = {
                      lng: this.mapInfo.detectLongitude,
                      lat: this.mapInfo.detectLatitude,
                    };
                    this.show = true;
                  });
                  this.drawMap();
                }
              });
            });
          }
        });
        this.model = JSON.parse(JSON.stringify(record));
        this.getrouteList();
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(this.$t('添加成功'));
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      //--------地图
      //地图默认方法
      mapReady({ BMap, map }) {
        this.BMap = BMap;
        this.map = map;
        // 回显定位
        var coordinate = {
          lng:this.model.detectLongitude,
          lat:this.model.detectLatitude
        };
        this.center = coordinate;
        // 新增时获取当前定位
        if(!this.model.id){
          let geolocation = new BMap.Geolocation();
          geolocation.getCurrentPosition(function(r) {
            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
              this.center = r.point;
              // let mk = new BMap.Marker(r.point);
              // map.addOverlay(mk);
              map.panTo(r.point);
              console.log('当前位置：', r.point);
            } else {
              console.log('定位失败');
            }
          }, {enableHighAccuracy: true})
        }
        var marker = new BMap.Marker(coordinate); // 创建标注
        map.addOverlay(marker); // 将标注添加到地图中
          
        // this.drawMap();//适当地方调用
          
        // 点击地图添加监听事件获取经纬度
        map.addEventListener("click", (e) => {
          // console.log(e.point.lng, e.point.lat);
        });
          
        //给地图添加鼠标移动事件
        map.addEventListener("mousemove", (e) => {
         //......
        });
      },
      /** 逆向解析地址 point */
      geocAddress(point) {
        let that = this;
        var geoc = new BMap.Geocoder();
        geoc.getLocation(point, function (geocInfo) {
          // 设置基本信息
          var addressInfo = geocInfo.addressComponents;
          that.addressInfo.longitude = point.lng;
          that.addressInfo.latitude = point.lat;
          that.addressInfo.province = addressInfo.province;
          that.addressInfo.city = addressInfo.city;
          that.addressInfo.district = addressInfo.district;
          let address = addressInfo.street + addressInfo.streetNumber;
          if (geocInfo.surroundingPois.length > 0) {
            address = address + geocInfo.surroundingPois[0].title;
          }
          that.addressInfo.address = address;
        });
      },
      //添加折线
      addPolyline(BMap, map, data, points, index) {
            let _this = this; //注意this的使用
            let polyline = "";
            // 创建折线
            polyline = new BMap.Polyline(points, {
              enableEditing: false, // 是否启用线编辑，默认为false
              // 设置折线颜色,可以设置不同颜色线路，需要自己定义
              strokeColor: this.colorAndIcon[0].lineColor, 
              strokeWeight: 5, // 折线宽度
              strokeOpacity: 1, // 折线透明度
            });
            // map.addOverlay(polyline); // 将折线添加到地图
            //折线点击事件
            polyline.addEventListener("click", function (e) {
              //......
            });
            for (let j = 0; j < points.length; j++) {
              this.addMarker(
                BMap,
                map,
                new BMap.Point(data[index][j].detectLongitude, data[index][j].detectLatitude),
                data[index][j],
                index
              );
            }
          },
       
       
        //添加icon和标识
         addMarker(BMap, map, point, number, index) {
            let marker = "";//线体坐标点
            let label = "";//icon上的文字
            let myIcon = new BMap.Icon(
              //也可以设置不同坐标点上的icon，需要自己定义
              this.colorAndIcon[0].icon, 
              new BMap.Size(30, 30), //图标可视区域大小
              { anchor: new BMap.Size(8, 8) } //图标定位点相对于图标左上角的偏移量
            );
            myIcon.setImageSize(new BMap.Size(20, 20)); // 设置icon大小
            marker = new BMap.Marker(point, { icon: myIcon }); // 创建图像标注
            map.addOverlay(marker); // 将标注添加到地图
            //icon标识内容位置
            label = new BMap.Label(number.deviceId, { offset: new BMap.Size(3, 0) });
            // 文本标识样式
            label.setStyle({
              // fontWeight: 600,
              fontSize: "14px",
              color: "black",
              backgroundColor: "#fff",
              border: '1px solid #000',
              display: 'none'
            });
            marker.setLabel(label); // 为icon添加文本标识
          },
          //站点数据处理  逻辑同上
          addStation(BMap, map, data, points, index) {
            for (let j = 0; j < points.length; j++) {
              this.addStationMarker(
                BMap,
                map,
                new BMap.Point(data[index].detectLongitude, data[index].ladetectLatitudet),
                j + 1,
                index
              );
            }
          },
          //添加站点标注
          addStationMarker(BMap, map, point, number, index) {
            let marker = "";
            let myIcon = new BMap.Icon(
              this.colorAndIcon[1].icon,
              new BMap.Size(30, 30),
              { anchor: new BMap.Size(8, 8) }
            );
            myIcon.setImageSize(new BMap.Size(18, 18)); 
            marker = new BMap.Marker(point, { icon: myIcon }); 
            map.addOverlay(marker);
          },
    }
  }
</script>
<style scoped lang="less">
  /deep/.ant-modal{
    top: 5px;
    padding-bottom: 0;
  }
  .form-item-series{
    display: flex;
    margin-top: 4px;
  }
</style>